export function prepareKey(key, customProps){
    let allowedTypes = customProps.allowedTypes
    let allowedExtensions = customProps.allowedExtensions;
    let returnkey = key;

    if(allowedTypes && allowedTypes.length){
        returnkey += '_'+allowedTypes.sort().join("-");
    }
    if(allowedExtensions && allowedExtensions.length){
        returnkey += '_'+allowedExtensions.sort().join("-");
    }
    return returnkey;
    // if(!allowedTypes || (allowedTypes && !allowedTypes.length)){
    //     return key
    // }
    // return key+'_'+allowedTypes.sort().join("-");
    ///key wil be like 123_abc-def-zxc
}